import {DunningData} from '../model/dunning-data.interface';

/**
 * Mock Dunning Data Set 2 - Higher amounts scenario
 * Customer with 3 contracts, higher dunning amounts and multiple charges
 */
export const MOCK_DUNNING_DATA_2: DunningData = {
  customerId: 10002,
  customerBillingAccountId: 20002,
  dunningId: 30002,
  contracts: [
    {
      identifier: '92889301',
      partner: 'Signal Iduna',
      type: 'Health Insurance',
      monthlyPrice: [
        {
          startMonth: '2023-06',
          monthlyPrice: 85.50
        },
        {
          startMonth: '2024-01',
          monthlyPrice: 92.30
        }
      ],
      currency: 'EUR',
      dunningMonths: 6,
      reactivationMonths: 8,
      dunningAmount: 553.80,
      reactivationAmount: 738.40,
      status: 'in-dunning'
    },
    {
      identifier: '92889302',
      partner: 'Ergo',
      type: 'Household Insurance',
      monthlyPrice: [
        {
          startMonth: '2024-01',
          monthlyPrice: 15.90
        }
      ],
      currency: 'EUR',
      dunningMonths: 4,
      reactivationMonths: 6,
      dunningAmount: 63.60,
      reactivationAmount: 95.40,
      status: 'in-dunning'
    },
    {
      identifier: '92889303',
      partner: 'HUK-Coburg',
      type: 'Car Insurance',
      monthlyPrice: [
        {
          startMonth: '2024-01',
          monthlyPrice: 45.00
        }
      ],
      currency: 'EUR',
      dunningMonths: 5,
      reactivationMonths: 7,
      dunningAmount: 225.00,
      reactivationAmount: 315.00,
      status: 'in-dunning'
    }
  ],
  charges: [
    {
      name: 'Court Fees',
      amount: 150.00,
      currency: 'EUR',
      deductable: false,
      reducable: false
    },
    {
      name: 'Administrative Fees',
      amount: 50.00,
      currency: 'EUR',
      deductable: true,
      reducable: true
    },
    {
      name: 'Collection Agency Fees',
      amount: 120.00,
      currency: 'EUR',
      deductable: false,
      reducable: true
    }
  ]
};
